<template>
  <el-dialog
    title="Kanun ve Yönetmelikler"
    :visible="Modal"
    center
    width="90%">
    <a @click="$emit('Modal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>

    <el-row :gutter="24">
      <el-col :span="6">
        <div class="borcliste vezne" :style="'height:'+Height+'px' ">
          <el-input
            v-if="IcerikMerkezi"
            placeholder="Arama"
            prefix-icon="el-icon-search"
            v-model="search">
          </el-input>
          <ul v-if="IcerikMerkezi" :style="'height:'+(Height-75)+'px' ">
            <li
              v-for="t in IcerikMerkezi.filter(data => !search || data.Baslik.toLowerCase().includes(search.toLowerCase()))"
              @click="Secim(t)" :class="t.id===Icerik_id?'Aktif':''">
              <div class="kisiBilgi">
                <span class="borcAd" style="text-transform: uppercase">{{ t.Baslik }}</span>
                <span class="borcBina">{{ t.Kategori }}</span>
              </div>
            </li>
            <el-alert
              :closable="false"
              v-if="!IcerikMerkezi.filter(data => !search || data.Baslik.toLowerCase().includes(search.toLowerCase()))[0]"
              title="Uygun Kayıt Bulunamadı"
              type="error">
            </el-alert>
          </ul>
        </div>
      </el-col>
      <el-col :span="18" v-loading="lo">
        <iframe title="Textsdsa" v-if="Dosya" :src="Dosya" :height="Height" width="100%" style="border:none"></iframe>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  props: ['Modal'],
  data() {
    return {
      search: '',
      Height: window.innerHeight - 140,
      IcerikMerkezi: null,
      lo: false,
      Icerik_id: null,
      Dosya: null,

    }
  },
  methods: {
    Secim(t) {
      this.Icerik_id = t.id
      this.Dosya = t.Dosya
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'spesiyal/icerikmerkezi'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.IcerikMerkezi = response.Liste;
          }
        });
    }
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Spesiyal/Kanunlar.vue